import {
    createSlice,
    createAsyncThunk
} from '@reduxjs/toolkit'
import api from '../../api/api'


export const get_category = createAsyncThunk(
    'product/get_category',
    async (_, {
        fulfillWithValue,
        rejectWithValue
    }) => {
        try {
            const {
                data
            } = await api.get('/home/get-categorys')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data || error.response)

        }
    }
)

export const get_products = createAsyncThunk(
    'product/get_products',
    async (query = {}, {
        fulfillWithValue,
        rejectWithValue
    }) => {
        try {
            const {
                data
            } = await api.get('/home/get-products', { params: { page: 1, limit: 5, ...query } })
            return fulfillWithValue({ ...data, append: !!query.append })
        } catch (error) {
           
            return rejectWithValue(error.response.data || error.response)
        }
    }
)
export const get_product = createAsyncThunk(
    'product/get_product',
    async (slug, {
        fulfillWithValue,
        rejectWithValue,
        signal
    }) => {
        try {
            const {
                data
            } = await api.get(`/home/get-product/${encodeURIComponent(slug)}`, { signal })

            return fulfillWithValue(data)
        } catch (error) {
            // Şəbəkə xətasında error.response olmur — oxumaq özü throw edirdi.
            return rejectWithValue(error.response?.data || { message: error.message || 'Məhsul yüklənmədi' })
        }
    }
)

export const price_range_product = createAsyncThunk(
    'product/price_range_product',
    async (_, {
        fulfillWithValue,
        rejectWithValue
    }) => {
        try {
            const {
                data
            } = await api.get('/home/price-range-latest-product')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data || error.response)
        }
    }
)
export const get_banners = createAsyncThunk(
    'product/get_banners',
    async (_, {
        fulfillWithValue,
        rejectWithValue
    }) => {
        try {
            const {
                data
            } = await api.get('/banners')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data || error.response)
        }
    }
)
export const query_products = createAsyncThunk(
    'product/query_products',
    async (query, {
        fulfillWithValue,
        rejectWithValue
    }) => {
        try {
            const {
                data
            } = await api.get('/home/query-products', {
                params: {
                    category: query.category || '',
                    rating: query.rating || '',
                    minRating: query.minRating || '',
                    lowPrice: query.low || '',
                    highPrice: query.high || '',
                    sortPrice: query.sortPrice || '',
                    seller: query.seller || '',
                    inStock: query.inStock ? 'true' : '',
                    automaticDelivery: query.automaticDelivery ? 'true' : '',
                    type: query.type || '',            // Phase 4H: vitrin | bumped | discount
                    page: query.pageNumber || query.page || 1,
                    limit: query.limit || 5,
                    offset: Number.isFinite(query.offset) ? query.offset : undefined,
                    searchValue: query.searchValue || ''
                }
            })
            return fulfillWithValue({ ...data, append: !!query.append })
        } catch (error) {

            return rejectWithValue(error.response.data || error.response)
        }
    }
)

// Phase 4K — strict promosyon feed-ləri (homepage bölmələri üçün)
// type=bumped → yalnız real yuxarı daşınmış (promotionBumpedAt) elanlar.
// Market `products` slice-ını əvəz ETMİR (ayrı slice: bumpedProducts).
export const get_bumped_listings = createAsyncThunk(
    'product/get_bumped_listings',
    async (query = {}, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/home/query-products', {
                params: { type: 'bumped', page: query.page || 1, limit: query.limit || 12 }
            })
            return fulfillWithValue({ ...data, append: !!query.append })
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

export const get_home_showcase_listings = createAsyncThunk(
    'product/get_home_showcase_listings',
    async (query = {}, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/home/query-products', {
                params: { type: 'home_showcase', page: query.page || 1, limit: query.limit || 12, offset: query.offset }
            })
            return fulfillWithValue({ ...data, append: !!query.append })
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

export const get_marketplace_showcase_listings = createAsyncThunk(
    'product/get_marketplace_showcase_listings',
    async (query = {}, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/home/query-products', {
                params: {
                    type: 'marketplace_showcase', page: 1,
                    limit: query.limit || 15, offset: query.offset || 0,
                    searchValue: query.searchValue || '', category: query.category || '',
                    minRating: query.minRating || '', lowPrice: query.low ?? '', highPrice: query.high ?? '',
                    seller: query.seller || '', inStock: query.inStock ? 'true' : '',
                    automaticDelivery: query.automaticDelivery ? 'true' : ''
                }
            })
            return fulfillWithValue({ ...data, append: !!query.append })
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

// Həftənin Fürsətləri teaser — /haftanin-firsatlari ilə EYNİ mənbə
// (/home/weekly-cycle: aktiv dövr slotları; flag bağlıdırsa legacy fallback).
export const get_weekly_listings = createAsyncThunk(
    'product/get_weekly_listings',
    async (query = {}, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/home/weekly-cycle', {
                params: { page: query.page || 1, limit: query.limit || 12 }
            })
            return fulfillWithValue({ ...data, append: !!query.append })
        } catch (error) {
            return rejectWithValue(error.response?.data || error.response)
        }
    }
)

export const customer_review = createAsyncThunk(
    'review/customer_review',
    async (info, {
        fulfillWithValue,
        rejectWithValue
    }) => {
        try {
            const {
                data
            } = await api.post('/home/customer/submit-review', info)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data || error.response)
        }
    }
)

export const get_reviews = createAsyncThunk(
    'review/get_reviews',
    async ({
        productId,
        pageNumber
    }, {
        fulfillWithValue,
        rejectWithValue
    }) => {
        try {
            const {
                data
            } = await api.get(`/home/customer/get-reviews/${productId}?pageNo=${pageNumber}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data || error.response)
        }
    }
)

export const homeReducer = createSlice({
    name: 'home',
    initialState: {
        categorys: [],
        products: [],
        premiumProducts: [],
        premiumTotal: 0,
        totalProduct: 0,
        parPage: 4,
        latest_product: [],
        topRated_product: [],
        discount_product: [],
        priceRange: {
            low: 0,
            high: 100
        },
        product: {},
        relatedProducts: [],
        moreProducts: [],
        // Product detail request lifecycle — `requestedSlug` is the guard that keeps a
        // slow response for an earlier product from overwriting the current one.
        requestedSlug: null,
        productLoader: false,
        productError: '',
        successMessage: '',
        errorMessage: '',
        totalReview: 0,
        rating_review: [],
        reviews: [],
        banners: [],
        sellerInfo: null,
        // Phase 4K — strict bumped feed (homepage "Önə çıxarılan elanlar")
        bumpedProducts: [],
        bumpedPagination: { page: 1, total: 0, totalPages: 0, hasNextPage: false },
        bumpedLoader: false,
        homeShowcaseProducts: [],
        homeShowcasePagination: { offset: 0, total: 0, hasNextPage: false },
        homeShowcaseLoader: false,
        marketplaceShowcaseProducts: [],
        marketplaceShowcasePagination: { offset: 0, total: 0, hasNextPage: false },
        marketplaceShowcaseLoader: false,
        weeklyListings: [],
        weeklyLoader: false
        ,
        pagination: {
            page: 1,
            limit: 5,
            total: 0,
            totalPages: 0,
            hasNextPage: false,
            hasPrevPage: false
        },
        loader: false
        
    },
    reducers: {
        messageClear: (state, _) => {
            state.successMessage = ""
            state.errorMessage = ""
        },
        clear_product_detail: (state, { payload }) => {
            state.product = {}
            state.relatedProducts = []
            state.moreProducts = []
            state.totalReview = 0
            state.sellerInfo = null
            state.productError = ''
            state.requestedSlug = payload || null
            state.productLoader = Boolean(payload)
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(get_products.pending, (state) => {
                state.loader = true
            })
        .addCase(get_category.fulfilled, (state, { payload }) => {
                state.categorys = payload.categorys;
            })

          .addCase(get_products.fulfilled, (state, { payload }) => {
                state.loader = false
                if (payload.append) {
                    const seen = new Set(state.products.map(product => String(product?._id)))
                    state.products = [...state.products, ...(payload.products || []).filter(product => {
                        const id = String(product?._id || '')
                        if (!id || seen.has(id)) return false
                        seen.add(id)
                        return true
                    })]
                } else state.products = Array.isArray(payload.products) ? payload.products : []
                state.pagination = payload.pagination || state.pagination
                state.totalProduct = payload.totalProduct || payload.pagination?.total || 0
                state.parPage = payload.parPage || payload.pagination?.limit || 5
                state.latest_product = payload.latest_product ;
                state.topRated_product = payload.topRated_product ;
                state.discount_product = payload.discount_product ;
            })
            .addCase(get_products.rejected, (state) => {
                state.loader = false
            })
            .addCase(get_product.pending, (state, { meta }) => {
                // Route dəyişdi → köhnə məhsul dərhal təmizlənir.
                state.requestedSlug = meta.arg
                state.productLoader = true
                state.productError = ''
                state.product = {}
                state.relatedProducts = []
                state.moreProducts = []
                state.totalReview = 0
                state.sellerInfo = null
            })
            .addCase(get_product.fulfilled, (state, { payload, meta }) => {
                // Başqa məhsulun gec gələn cavabı cari məhsulu əvəz etməməlidir.
                if (meta.arg !== state.requestedSlug) return
                state.productLoader = false
                state.productError = ''
                state.product = payload.product;          // ✅ sellerInfo daxil olmaqla hamısı
                state.relatedProducts = payload.relatedProducts;
                state.moreProducts = payload.moreProducts;
                state.totalReview = payload.totalReview;
                state.sellerInfo = payload.sellerInfo
            })
            .addCase(get_product.rejected, (state, { payload, meta }) => {
                // Abort = biz özümüz ləğv etmişik (route dəyişdi / unmount) — xəta deyil.
                if (meta.aborted || meta.arg !== state.requestedSlug) return
                state.productLoader = false
                state.productError = payload?.message || 'Məhsul yüklənmədi'
            })

            .addCase(price_range_product.fulfilled,(state, {payload}) => {
               state.latest_product = payload.latest_product
               state.priceRange = payload.priceRange
            })

            .addCase(query_products.pending, (state) => {
                state.loader = true
            })
            .addCase(query_products.fulfilled,(state, {payload}) => {
                state.loader = false
                if (payload.append) {
                    const seen = new Set(state.products.map(product => product._id))
                    state.products = [
                        ...state.products,
                        ...(payload.products || []).filter(product => {
                            if (!product?._id || seen.has(product._id)) return false
                            seen.add(product._id)
                            return true
                        })
                    ]
                } else {
                    state.products = Array.isArray(payload?.products) ? payload.products : []
                    state.premiumProducts = Array.isArray(payload?.premiumProducts) ? payload.premiumProducts : []
                    state.premiumTotal = Number(payload?.premiumTotal) || 0
                }
            state.totalProduct = payload.totalProduct
            state.parPage = payload.parPage || payload.pagination?.limit || 5
            state.pagination = payload.pagination || state.pagination
            })
            .addCase(query_products.rejected, (state) => {
                state.loader = false
            })

            // Phase 4K — strict bumped feed
            .addCase(get_bumped_listings.pending, (state) => {
                state.bumpedLoader = true
            })
            .addCase(get_bumped_listings.fulfilled, (state, { payload }) => {
                state.bumpedLoader = false
                const next = payload.products || []
                if (payload.append) {
                    const seen = new Set(state.bumpedProducts.map(p => p._id))
                    state.bumpedProducts = [
                        ...state.bumpedProducts,
                        ...next.filter(p => p?._id && !seen.has(p._id) && (seen.add(p._id), true))
                    ]
                } else {
                    state.bumpedProducts = next
                }
                state.bumpedPagination = payload.pagination || state.bumpedPagination
            })
            .addCase(get_bumped_listings.rejected, (state) => {
                state.bumpedLoader = false
            })
            .addCase(get_home_showcase_listings.pending, (state) => {
                state.homeShowcaseLoader = true
            })
            .addCase(get_home_showcase_listings.fulfilled, (state, { payload }) => {
                state.homeShowcaseLoader = false
                const next = Array.isArray(payload?.products) ? payload.products : []
                if (payload.append) {
                    const seen = new Set(state.homeShowcaseProducts.map(product => String(product?._id)))
                    state.homeShowcaseProducts = [...state.homeShowcaseProducts, ...next.filter(product => {
                        const id = String(product?._id || '')
                        if (!id || seen.has(id)) return false
                        seen.add(id)
                        return true
                    })]
                } else state.homeShowcaseProducts = next
                state.homeShowcasePagination = payload.pagination || state.homeShowcasePagination
            })
            .addCase(get_home_showcase_listings.rejected, (state) => {
                state.homeShowcaseLoader = false
            })
            .addCase(get_marketplace_showcase_listings.pending, (state) => {
                state.marketplaceShowcaseLoader = true
            })
            .addCase(get_marketplace_showcase_listings.fulfilled, (state, { payload }) => {
                state.marketplaceShowcaseLoader = false
                const next = Array.isArray(payload?.products) ? payload.products : []
                if (payload.append) {
                    const seen = new Set(state.marketplaceShowcaseProducts.map(product => String(product?._id)))
                    state.marketplaceShowcaseProducts = [...state.marketplaceShowcaseProducts, ...next.filter(product => {
                        const id = String(product?._id || '')
                        if (!id || seen.has(id)) return false
                        seen.add(id)
                        return true
                    })]
                } else state.marketplaceShowcaseProducts = next
                state.marketplaceShowcasePagination = payload.pagination || state.marketplaceShowcasePagination
            })
            .addCase(get_marketplace_showcase_listings.rejected, (state) => {
                state.marketplaceShowcaseLoader = false
            })
            .addCase(get_weekly_listings.pending, (state) => {
                state.weeklyLoader = true
            })
            .addCase(get_weekly_listings.fulfilled, (state, { payload }) => {
                state.weeklyLoader = false
                state.weeklyListings = payload.products || []
            })
            .addCase(get_weekly_listings.rejected, (state) => {
                state.weeklyLoader = false
            })

            .addCase(customer_review.fulfilled,(state, {payload}) => {
                state.successMessage = payload.message
            })

             .addCase(get_reviews.fulfilled,(state, {payload}) => {
                state.reviews = payload.reviews
                state.totalReview = payload.totalReview
                state.rating_review = payload.rating_review
            })
            .addCase(get_banners.fulfilled, (state, { payload }) => {
            state.banners = payload.banners
        })
    }
})

export const {
    messageClear,
    clear_product_detail
} = homeReducer.actions
export default homeReducer.reducer

